import type { ReportDB } from '@creator/sdk/modules/report/report.model';
import { useAtomValue } from 'jotai';
import { useMemo } from 'react';
import { getReportsAtom } from '../reports';

export const useReportsByIds = (reportIds: string[]): ReportDB[] => {
    const reportsMap = useAtomValue(getReportsAtom());

    return useMemo(() => {
        return reportIds.map(id => reportsMap[id]).filter(Boolean) as ReportDB[];
    }, [reportIds, reportsMap]);
};
